// One mark per plan, used at every size: 64px on the pricing cards, ~13px
// inside PlanBadge. Defined once so the hero icon and the pill can never
// drift apart.
//
// Marks come from the two-tone set (components/icons.tsx), so a plan reads
// the same everywhere regardless of the surrounding tone.
import { Building2, Cloud, Cpu, Gauge, Sparkles } from "./icons";
import type { PlanId } from "../api/types";

/** "local" is the informational hardware tier on the landing page — it is
 *  not a subscription, so it is not a PlanId. */
export type PlanIconKey = PlanId | "local";

const ICONS: Record<PlanIconKey, typeof Cloud> = {
  local: Cpu,        // the hardware itself, no cloud involved
  free: Cloud,
  basic: Gauge,      // remote control and alerts arrive here
  pro: Sparkles,     // optimization intelligence
  fleet: Building2,  // many sites, many people
};

export function PlanIcon({
  plan,
  size = 16,
  className = "",
}: {
  plan: PlanIconKey;
  size?: number;
  className?: string;
}) {
  const Icon = ICONS[plan] ?? Cloud;
  // Decorative: the plan name is always rendered beside it.
  return <Icon size={size} className={className} aria-hidden="true" />;
}
